document.addEventListener("DOMContentLoaded", function () {
  const educationSections = document.querySelectorAll('.education-scroll-bar');
  
  educationSections.forEach(section => {
    
    const activeEducationLink = section.querySelector('a.active-education');
    
    if (activeEducationLink) {
      activeEducationLink.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center"
      });
  
      activeEducationLink.focus();
    }
  });
});

// var element = document.getElementById("insta-feed");
// var parent = element.closest("section");

// if(parent){
//     parent.style.overflowX = "hidden";
// }
